import {
  IconButton,
  Card,
  CardContent,
  Tooltip,
  Button,
} from "@material-ui/core";
import { Edit, Delete, Add } from "@mui/icons-material";
import { columnTextField } from "utils/tables-utils";
import TableComponent from "components/_refactor/table/table";

export default function TableCategoria({
  data = [],
  onEdit,
  onDelete,
  onCreate,
  loading,
}) {
  const columnModel = [
    columnTextField({
      dataField: "Nome",
      text: "Nome",
      align: "left",
    }),
    columnTextField({
      dataField: "Descricao",
      text: "Descrição",
      align: "left",
    }),
    columnTextField({
      dataField: "Edit",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Editar">
            <IconButton size="small" onClick={() => onEdit(row)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnTextField({
      dataField: "Delete",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Excluir">
            <IconButton size="small" onClick={() => onDelete(row)}>
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }),
  ];

  return (
    <Card>
      <CardContent>
        <TableComponent
          dataTable={data}
          columnModel={columnModel}
          loading={loading}
          headerTitle="Categorias de Materiais"
          keyField="IdDocumentoAreaCategoria"
          pagination={{
            page: 1,
            sizePerPage: 10,
            totalSize: data.length,
          }}
          extraActions={
            <Button variant="contained" onClick={onCreate}>
              <Add /> Criar Regra
            </Button>
          }
        />
      </CardContent>
    </Card>
  );
}
